import { useState, useEffect, useCallback } from "react";
import { VideoItem, SEED_VIDEOS } from "../types/video.js";
import { fetchVideos } from "../services/videoService.js";

export function useVideos(options?: { limit?: number; category?: string }) {
  const [videos, setVideos] = useState<VideoItem[]>(SEED_VIDEOS);
  const [isLoading, setIsLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  const loadVideos = useCallback(async () => {
    setIsLoading(true);
    setError(null);
    try {
      const items = await fetchVideos(options);
      setVideos(items);
    } catch (err) {
      setError((err as Error).message);
      setVideos(SEED_VIDEOS);
    } finally {
      setIsLoading(false);
    }
  }, [options?.limit, options?.category]);

  useEffect(() => {
    loadVideos();

    const handleVideoEvent = () => {
      loadVideos();
    };

    if (typeof window !== "undefined") {
      window.addEventListener("helix_video_uploaded", handleVideoEvent);
      window.addEventListener("helix_video_deleted", handleVideoEvent);
      window.addEventListener("storage", handleVideoEvent);
    }

    return () => {
      if (typeof window !== "undefined") {
        window.removeEventListener("helix_video_uploaded", handleVideoEvent);
        window.removeEventListener("helix_video_deleted", handleVideoEvent);
        window.removeEventListener("storage", handleVideoEvent);
      }
    };
  }, [loadVideos]);

  return {
    videos,
    isLoading,
    error,
    refetch: loadVideos,
  };
}
